import React, { useEffect, useState } from "react"
import { useParams } from "react-router"
import { useNavigate } from "react-router-dom"
import DashboardLayout from "../../soft_dashboard/examples/LayoutContainers/DashboardLayout"
import DashboardNavbar from "../../soft_dashboard/examples/Navbars/DashboardNavbar"
import SoftBox from "../../soft_dashboard/components/SoftBox"

import Axios from "../../Util/Axios"
import DescriptionItem from "../core/DescriptionItem/DescriptionItem"
import SoftTypography from "../../soft_dashboard/components/SoftTypography"
import Card from "@mui/material/Card"
import CustomTextField from "../core/CustomTextField/CustomTextField"
import Button from "@mui/material/Button"
import { updateToastData } from "../../slices/toastSlice"
import {
  TOAST_SEVERITY_ERROR,
  TOAST_SEVERITY_SUCCESS,
} from "../core/Toast/Toast"
import { useDispatch } from "react-redux"

const StaffSettings = ({ prop }) => {
  const [siteConfiguration, setSiteConfiguration] = useState(false)
  const [accessToken, setAccessToken] = useState("")
  const [loading, setLoading] = useState(false)
  const [passwordLoading, setPasswordLoading] = useState(false)
  const [passwordData, setPasswordData] = useState({
    current_password: "",
    new_password: "",
    confirm_password: "",
  })
  const [passwordError, setPasswordError] = useState("")
  const dataUrl = `/api/staff-site-configuration/1/`
  const passwordChangeUrl = `/api/change-password/`
  const dispatch = useDispatch()

  useEffect(() => {
    Axios.get(dataUrl).then(({ data }) => {
      setSiteConfiguration(data)
      setAccessToken(data.instagram_long_lived_access_token)
    })
  }, [])

  const handlePasswordChange = (e) => {
    const { name, value } = e.target
    setPasswordData({
      ...passwordData,
      [name]: value,
    })
  }

  const validatePasswordForm = () => {
    setPasswordError("")

    if (!passwordData.current_password) {
      setPasswordError("Current password is required")
      return false
    }

    if (!passwordData.new_password) {
      setPasswordError("New password is required")
      return false
    }

    if (passwordData.new_password !== passwordData.confirm_password) {
      setPasswordError("New passwords do not match")
      return false
    }

    return true
  }

  const submitPasswordChange = () => {
    if (!validatePasswordForm()) {
      return
    }

    setPasswordLoading(true)
    let data = {
      old_password: passwordData.current_password,
      new_password1: passwordData.new_password,
      new_password2: passwordData.confirm_password,
    }
    console.log(data)
    Axios.post(passwordChangeUrl, data)
      .then(() => {
        setPasswordLoading(false)
        setPasswordData({
          current_password: "",
          new_password: "",
          confirm_password: "",
        })
        dispatch(
          updateToastData({
            message: "Password changed successfully",
            severity: TOAST_SEVERITY_SUCCESS,
          })
        )
      })
      .catch((error) => {
        setPasswordLoading(false)
        let errorMessage = "Failed to change password"
        if (error.response && error.response.data) {
          if (error.response.data.old_password) {
            errorMessage = error.response.data.old_password[0]
          } else if (error.response.data.new_password1) {
            errorMessage = error.response.data.new_password1[0]
          } else if (error.response.data.non_field_errors) {
            errorMessage = error.response.data.non_field_errors[0]
          }
        }
        setPasswordError(errorMessage)
        dispatch(
          updateToastData({
            message: errorMessage,
            severity: TOAST_SEVERITY_ERROR,
          })
        )
      })
  }

  return (
    <DashboardLayout>
      <DashboardNavbar
        pageTitle={
          <SoftBox display="flex" alignItems="center">
            <SoftBox>Settings</SoftBox>
          </SoftBox>
        }
      />
      <SoftBox mt={4} mb={1.5}>
        <Card sx={{ height: "100%", marginBottom: "24px" }}>
          <SoftBox p={2}>
            <DescriptionItem
              keyJsx={
                <div>
                  <SoftTypography
                    display="block"
                    variant="button"
                    fontWeight="medium"
                  >
                    Instagram Access Token
                  </SoftTypography>

                  <SoftTypography
                    display="block"
                    variant="button"
                    fontWeight="medium"
                  >
                    Expires:{" "}
                    {
                      siteConfiguration?.instagram_long_lived_access_token_expires_at
                    }
                  </SoftTypography>
                </div>
              }
              valueJsx={
                <div
                  style={{ display: "flex", gap: "16px", alignItems: "center" }}
                >
                  <CustomTextField
                    disabled={loading}
                    value={accessToken}
                    fullWidth={true}
                    onChange={(event) => {
                      setAccessToken(event.target.value)
                    }}
                  ></CustomTextField>
                  <Button
                    variant="contained"
                    color={"info"}
                    disabled={loading}
                    fullWidth
                    onClick={() => {
                      setLoading(true)
                      Axios.patch(dataUrl, {
                        instagram_long_lived_access_token: accessToken,
                        instagram_long_lived_access_token_expires_at: null,
                      })
                        .then(({ data }) => {
                          setSiteConfiguration({
                            ...siteConfiguration,
                            instagram_long_lived_access_token_expires_at:
                              data.instagram_long_lived_access_token_expires_at,
                          })
                          setLoading(false)
                          dispatch(
                            updateToastData({
                              message: "Instagram Access Token Updated",
                              severity: TOAST_SEVERITY_SUCCESS,
                            })
                          )
                        })
                        .catch((e) => {
                          setLoading(false)
                          dispatch(
                            updateToastData({
                              message: "Instagram Access Token not Updated",
                              severity: TOAST_SEVERITY_ERROR,
                            })
                          )
                        })
                    }}
                  >
                    Save
                  </Button>
                </div>
              }
            />
          </SoftBox>
        </Card>

        <Card sx={{ height: "100%" }}>
          <SoftBox p={2}>
            <SoftTypography
              display="block"
              variant="button"
              fontWeight="medium"
              mb={2}
            >
              Change Password
            </SoftTypography>

            {passwordError && (
              <SoftBox mb={2}>
                <SoftTypography
                  display="block"
                  variant="button"
                  color="error"
                  fontWeight="medium"
                >
                  {passwordError}
                </SoftTypography>
              </SoftBox>
            )}

            <SoftBox mb={2}>
              <CustomTextField
                label="Current Password"
                type="password"
                name="current_password"
                value={passwordData.current_password}
                onChange={handlePasswordChange}
                disabled={passwordLoading}
                fullWidth={true}
              />
            </SoftBox>

            <SoftBox mb={2}>
              <CustomTextField
                label="New Password"
                type="password"
                name="new_password"
                value={passwordData.new_password}
                onChange={handlePasswordChange}
                disabled={passwordLoading}
                fullWidth={true}
              />
            </SoftBox>

            <SoftBox mb={2}>
              <CustomTextField
                label="Confirm New Password"
                type="password"
                name="confirm_password"
                value={passwordData.confirm_password}
                onChange={handlePasswordChange}
                disabled={passwordLoading}
                fullWidth={true}
              />
            </SoftBox>

            <SoftBox display="flex" justifyContent="flex-end">
              <Button
                variant="contained"
                color="info"
                disabled={passwordLoading}
                onClick={submitPasswordChange}
              >
                Change Password
              </Button>
            </SoftBox>
          </SoftBox>
        </Card>
      </SoftBox>
    </DashboardLayout>
  )
}

export default StaffSettings
